import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import GanttSideEntry, { GanttSideEntryMetaItem } from 'components/GanttSideEntry';

import UserName from './user-name';
import DateTime from 'components/DateTime';

import IconUser from '../icons/icon-user';
import IconNumber from '../icons/icon-number';
import IconCalendarSimple from '../icons/icon-calendar-simple';
import IconArrowRight from '../icons/icon-arrow-right';
import IconArrowDown from '../icons/icon-arrow-down';
import IconRoadmap from '../icons/icon-roadmap';

const ProjectGanttSummary = ({ project, progress, type, hasMilestones, milestonesCount, projectEnd, expanded, compactView, rowHeight, onClick, onExpand }) => {
    const { t } = useTranslation(['project', 'common', 'milestone']);

    const avatarProps = useMemo(() => ({
        image: project?.logo,
        text: project?.initials,
        color: project?.color,
        secondaryColor: project?.secondary_color
    }), [project?.logo, project?.initials, project?.color, project?.secondary_color]);

    if (!project) {
        return null;
    }

    return (
        <GanttSideEntry
            title={project.name}
            avatarProps={avatarProps}
            progress={progress}
            type={type}
            mainHeight={rowHeight - 1}
            onClick={onClick}
        >
            {
                compactView ? null : hasMilestones ? (
                    <GanttSideEntryMetaItem
                        icon={<IconCalendarSimple />}
                        title={(
                            <React.Fragment>
                                { type === 'completed' ? `${t('common:Completed on')}:` : `${t('common:Est Completion')}:` }

                                &nbsp;

                                <DateTime format="date">{projectEnd}</DateTime>
                            </React.Fragment>
                        )}
                        additional={<DateTime fromNow>{projectEnd}</DateTime>}
                    />
                ) : (
                    <GanttSideEntryMetaItem
                        icon={<IconCalendarSimple />}
                        title={ t('milestone:noEntries.shortAlt') }
                    />
                )
            }
            {
                !compactView && project.total_story_points ? (
                    <GanttSideEntryMetaItem
                        icon={<IconNumber />}
                        title={(
                            <React.Fragment>
                                { t('common:Story Points') }:&nbsp;

                                { project.completed_story_points } of { project.total_story_points }
                            </React.Fragment>
                        )}
                    />
                ) : null
            }

            {
                !hasMilestones ? null : (
                    <GanttSideEntryMetaItem
                        icon={<IconRoadmap />}
                        title={ t('milestone:Milestones_count', { count: milestonesCount } ) }
                        iconAfter={onExpand && (expanded ? <IconArrowDown /> : <IconArrowRight />)}
                        onClick={onExpand ? onExpand : undefined}
                    />
                )
            }
        </GanttSideEntry>
    )
}

export default ProjectGanttSummary;
